import type { editor } from "monaco-editor";

export const MONACO_OPTIONS = (readOnly: boolean): editor.IStandaloneEditorConstructionOptions => ({
    minimap: { enabled: false },
    scrollBeyondLastLine: false,
    fontSize: 13,
    lineHeight: 20,
    padding: { top: 8 },
    readOnly,
    lineNumbers: "on",
    wordWrap: "off",
    automaticLayout: true,
    renderLineHighlight: "none",
    stickyScroll: { enabled: false },
    // Disable Monaco's built-in scroll shadows (the inset shadow shown at the edges when scrolled).
    scrollbar: { useShadows: false },
    fontFamily: "'SF Mono', 'Fira Code', 'Cascadia Code', monospace",
});
